import { useId } from "react";
import type { YoutubeFormat } from "@nexus/contracts";
import { useTranslation } from "react-i18next";

import {
  ChoiceCardGroup,
  type ChoiceCardOption,
} from "../../sets/CreatePersonaSetDialog/ChoiceCardGroup.js";

export const YOUTUBE_FORMAT_OFF = "off";

export type YoutubeFormatChoice = typeof YOUTUBE_FORMAT_OFF | YoutubeFormat;

export function youtubeFormatRequestField(
  choice: YoutubeFormatChoice,
): { youtubeFormat: YoutubeFormat } | Record<string, never> {
  if (choice === YOUTUBE_FORMAT_OFF) return {};
  return { youtubeFormat: choice };
}

export function YoutubeFormatField({
  value,
  onChange,
  disabled = false,
}: {
  value: YoutubeFormatChoice;
  onChange: (value: YoutubeFormatChoice) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  const id = useId();
  const options: ChoiceCardOption<YoutubeFormatChoice>[] = [
    {
      value: YOUTUBE_FORMAT_OFF,
      title: t("personaOpportunities.generateScripts.youtubeFormat.meta", "Meta"),
    },
    {
      value: "in_stream_16_9",
      title: t(
        "personaOpportunities.generateScripts.youtubeFormat.inStream",
        "YT In-Stream (16:9)",
      ),
    },
    {
      value: "shorts_9_16",
      title: t("personaOpportunities.generateScripts.youtubeFormat.shorts", "YT Shorts (9:16)"),
    },
  ];

  return (
    <div data-testid="youtube-format">
      <h3 className="mb-2 text-[13px] font-medium text-foreground">
        {t("personaOpportunities.generateScripts.youtubeFormat.section", "Format & Placement")}
      </h3>
      <ChoiceCardGroup
        id={id}
        hideLabel
        label={t("personaOpportunities.generateScripts.youtubeFormat.group", "Format")}
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
}
